import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class StatsClickEvent extends ClickEvent {
  gameId: Number;
  status: Number;
  source: String;

  constructor(params) {
    super('', 'click', 'stats');

    this.gameId = params.gameId;
    this.status = params.status;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.source = this.source;

    return properties;
  }
}
